<template>
  <div style="display:flex; flex-direction:column">
    <div class="operations">
      <div class="triggers">
        <div>
          <el-button :disabled="((!innerIsEditing || Boolean(isSeaHouseChannel && manifestInfo.manifestId)) && manifestInfo.todo !== 'new')" type="primary" @click="showEditDialog(true)">{{ $t('Payment.new') }}</el-button>
          <el-button v-if="isSeaHouseChannel" :disabled="((!innerIsEditing || Boolean(isSeaHouseChannel && manifestInfo.manifestId)))" type="primary" @click="copy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
          <el-button :disabled="((!innerIsEditing || Boolean(isSeaHouseChannel && manifestInfo.manifestId)) && manifestInfo.todo !== 'new')" type="primary" @click="showEditDialog(false)">{{ $t('Payment.edit2') }}</el-button>
          <el-button :disabled="((!innerIsEditing || Boolean(isSeaHouseChannel && manifestInfo.manifestId)) && manifestInfo.todo !== 'new')" type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
        </div>
      </div>
    </div>
    <cargo-ag-grid
      config-module="130204"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="finalRowData"
      style="width:100%;height:200px;margin-top:5px"
      @gridReady="onGridReady"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Payment.containerNo')">
            <el-input v-model="editDialog.form.containerNo" :disabled="!isEditing" @change="editDialog.form.containerNo=toUpperCaseTrim(editDialog.form.containerNo)" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SealNo')">
            <el-input v-model="editDialog.form.sealNo" :disabled="!isEditing" @change="editDialog.form.sealNo=toUpperCaseTrim(editDialog.form.sealNo)" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerSize')">
            <el-input v-model="editDialog.form.eqSize" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.WeighingMethod')">
            <el-input v-model="editDialog.form.vgmWeightingMeothd" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item v-if="isSeaHouseChannel" :label="$t('SeaExport.TotalWeight2')">
            <el-input-number
              v-model="editDialog.form.vgmWeight"
              :disabled="!isEditing"
              :controls="false"
              :min="0"
              :precision="3"
              style="width:100%"
              @blur="editDialog.form.vgmWeight=roundHalfUp(editDialog.form.vgmWeight,3)"
            />
          </el-form-item>
          <el-form-item v-else :label="$t('SeaExport.TotalWeight2')">
            <el-input-number
              v-model="editDialog.form.vgmWeight"
              :disabled="!isEditing"
              :controls="false"
              :min="0"
              :precision="3"
              style="width:70%"
              @blur="editDialog.form.vgmWeight=roundHalfUp(editDialog.form.vgmWeight,3)"
            />
            <el-select v-model="editDialog.form.vgmWeightUnit" style="width:30%">
              <el-option
                v-for="item in WEIGHT_UNIT"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.VGMLLC')">
            <el-input v-model="editDialog.form.vgmLiabilityCompany" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.VGMSignature')">
            <el-input v-model="editDialog.form.vgmAutoGraph" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Email2')">
            <el-input v-model="editDialog.form.contactEmail" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item v-if="isSeaHouseChannel" :label="$t('SeaExport.TareWeight')">
            <el-input-number
              v-model="editDialog.form.grossWeight"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:100%"
              @blur="editDialog.form.grossWeight=roundHalfUp(editDialog.form.grossWeight,3)"
            />
          </el-form-item>
          <el-form-item v-else :label="$t('SeaExport.TareWeight')">
            <el-input-number
              v-model="editDialog.form.grossWeight"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:70%"
              @blur="editDialog.form.grossWeight=roundHalfUp(editDialog.form.grossWeight,3)"
            />
            <el-select v-model="editDialog.form.grossWeightUnit" style="width:30%">
              <el-option
                v-for="item in WEIGHT_UNIT"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="editDialog.form.telephone" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.WeighingAddress')">
            <el-input v-model="editDialog.form.weighingAddress" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item v-if="!isSeaHouseChannel" :label="$t('SeaExport.WeightTime')">
            <el-date-picker
              v-model="editDialog.form.weightTime"
              :disabled="!isEditing"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              style="width:100%"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="innerIsEditing" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ innerIsEditing?$t('common.btn.cancel'):$t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ErrorTip } from '@/utils/class/ErrorTip'
import { roundHalfUp } from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import { ManifestVGMInfo } from '@/class/model/booking/ManifestVGMInfo'
import { WEIGHT_UNIT } from '@/class/cargo/model/parameters/SeaExportConstants'
import * as commonUtil from '@/utils/commonUtil'

export default {
  name: 'BookingManifestVGMInfo',
  props: {
    job: { type: Object, required: true },
    manifestInfo: { type: Object, required: true },
    isSeaHouseChannel: { type: Boolean, default: false },
    isEditing: { type: Boolean, required: true }
  },
  data() {
    return {
      roundHalfUp,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onRowClicked: this.onRowClicked,
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      selectedRow: null,
      autoIncrementNum: new AutoIncrementNum(),
      editDialog: {
        visible: false,
        title: '',
        form: new ManifestVGMInfo().fillDefaultValue().getData()
      },
      WEIGHT_UNIT
    }
  },
  computed: {
    innerIsEditing() {
      return this.isEditing && Boolean(this.manifestInfo.uuid)
    },
    columnDefs() {
      let columnDefs
      if (this.isSeaHouseChannel) {
        columnDefs = [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('Payment.containerNo'),
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            cellRenderer: (params) => {
              return this.formatConversion(params.value)
            },
            cellEditorParams: {
              inputProps: {
                maxlength: 11
              }
            }
          }, {
            headerName: this.$t('SeaExport.SealNo'),
            colId: 'sealNo',
            field: 'sealNo',
            width: 100
          }, {
            headerName: this.$t('SeaExport.ContainerSize'),
            colId: 'eqSize',
            field: 'eqSize',
            width: 100
          }, {
            headerName: this.$t('SeaExport.WeighingMethod'),
            colId: 'vgmWeightingMeothd',
            field: 'vgmWeightingMeothd',
            width: 100
          }, {
            headerName: this.$t('SeaExport.TotalWeight2'),
            colId: 'vgmWeight',
            field: 'vgmWeight',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.number3ColumnLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('SeaExport.VGMLLC'),
            colId: 'vgmLiabilityCompany',
            field: 'vgmLiabilityCompany',
            width: 100
          }, {
            headerName: this.$t('SeaExport.VGMSignature'),
            colId: 'vgmAutoGraph',
            field: 'vgmAutoGraph',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Email2'),
            colId: 'contactEmail',
            field: 'contactEmail',
            width: 100
          }, {
            headerName: this.$t('SeaExport.TareWeight'),
            colId: 'grossWeight',
            field: 'grossWeight',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.number3ColumnLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('SeaExport.Tel'),
            colId: 'telephone',
            field: 'telephone',
            width: 100
          }, {
            headerName: this.$t('SeaExport.WeighingAddress'),
            colId: 'weighingAddress',
            field: 'weighingAddress',
            width: 100
          }, {
            headerName: this.$t('FileHistory.operation'),
            colId: '_operate',
            field: '',
            width: 100,
            cellRendererFramework: 'iconDocumentCopy',
            custom: {
              isEdit: this.innerIsEditing,
              clicked: p => { this.copyAndAddItem(p) }
            }
          }
        ]
      } else {
        columnDefs = [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('Payment.containerNo'),
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            cellRenderer: (params) => {
              return this.formatConversion(params.value)
            },
            cellEditorParams: {
              inputProps: {
                maxlength: 11
              }
            }
          }, {
            headerName: this.$t('SeaExport.SealNo'),
            colId: 'sealNo',
            field: 'sealNo',
            width: 100,
            cellRenderer: (params) => {
              return this.formatConversion(params.value)
            },
            cellEditorParams: {
              inputProps: {
                maxlength: 29
              }
            }
          }, {
            headerName: this.$t('SeaExport.ContainerSize'),
            colId: 'eqSize',
            field: 'eqSize',
            width: 100
          }, {
            headerName: this.$t('SeaExport.WeighingMethod'),
            colId: 'vgmWeightingMeothd',
            field: 'vgmWeightingMeothd',
            width: 100
          }, {
            headerName: this.$t('SeaExport.TotalWeight2'),
            colId: 'vgmWeight',
            field: 'vgmWeight',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.number3ColumnLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('SeaExport.TotalWeightUnit'),
            colId: 'vgmWeightUnit',
            field: 'vgmWeightUnit',
            width: 100
          }, {
            headerName: this.$t('SeaExport.VGMLLC'),
            colId: 'vgmLiabilityCompany',
            field: 'vgmLiabilityCompany',
            width: 100
          }, {
            headerName: this.$t('SeaExport.VGMSignature'),
            colId: 'vgmAutoGraph',
            field: 'vgmAutoGraph',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Email2'),
            colId: 'contactEmail',
            field: 'contactEmail',
            width: 100
          }, {
            headerName: this.$t('SeaExport.TareWeight'),
            colId: 'grossWeight',
            field: 'grossWeight',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.number3ColumnLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('SeaExport.TareWeightUnit'),
            colId: 'grossWeightUnit',
            field: 'grossWeightUnit',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Tel'),
            colId: 'telephone',
            field: 'telephone',
            width: 100
          }, {
            headerName: this.$t('SeaExport.WeighingAddress'),
            colId: 'weighingAddress',
            field: 'weighingAddress',
            width: 100
          }, {
            headerName: this.$t('SeaExport.WeightTime'),
            colId: 'weightTime',
            field: 'weightTime',
            width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('FileHistory.operation'),
            colId: '_operate',
            field: '',
            width: 100,
            cellRendererFramework: 'iconDocumentCopy',
            custom: {
              isEdit: this.innerIsEditing,
              clicked: p => { this.copyAndAddItem(p) }
            }
          }
        ]
      }
      return columnDefs
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  watch: {
    manifestInfo(newVal) {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    formatConversion(value) {
      return value ? String(value).trim().toUpperCase() : ''
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedRow = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            this.selectedRow = node.data
          }
        })
      }
    },
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedRow = null
      if (event.node.isSelected()) {
        this.selectedRow = event.data
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = event.data
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    init() {
      if (this.manifestInfo.uuid) {
        this.toQuery()
      } else {
        this.rowData = this.manifestInfo.manifestVGMs = []
      }
    },
    async toQuery() {
      const manifestInfo = new ManifestInfo(this.manifestInfo)
      this.rowData = await manifestInfo.getManifestVGMs()
    },
    showEditDialog(isNew, newRow) {
      if (isNew) {
        if (!newRow) {
          newRow = new ManifestVGMInfo().fillDefaultValue().getData()
          newRow.grossWeightUnit = 'KGS'
          newRow.vgmWeightUnit = 'KGS'
        }
        newRow.manifestInfoUuid = this.manifestInfo.uuid
        this.editDialog.form = newRow
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        if (!this.isEditing) { // 查看
          this.editDialog.form = newRow
          this.editDialog.title = this.$t('common.btn.look')
        } else {
          const row = this.selectedRow
          if (!row) {
            this.$message.warning(this.$t('common.tips.hasOneAtleast'))
            return
          }
          if (!row.seq) {
            row.seq = this.autoIncrementNum.getNextNum()
          }
          this.editDialog.form = { ...row }
          this.editDialog.title = this.$t('common.btn.edit')
        }
      }
      this.editDialog.visible = true
    },
    checkModel(form) {
      if (!form.containerNo) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.CaseNumberCannotBeEmpty')}`)
      }
      if (!form.sealNo) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.TheSealNumberCannotBeEmpty')}`)
      }
      if (!form.eqSize) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.BoxTypeCannotBeEmpty')}`)
      }
      if (!form.vgmWeightingMeothd) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.WeighingMethodCannotBeEmpty')}`)
      }
      if (form.vgmWeight <= 0) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.TheWeightCannotBeEmpty')}`)
      }
      if (!form.vgmLiabilityCompany) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.VGMCompanyCannotBeEmpty')}`)
      }
      if (!form.vgmAutoGraph) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.VGMSignatureCannotBeEmpty')}`)
      }
      if (!form.contactEmail) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.MailboxCannotBeEmpty')}`)
      }
      if (!form.telephone) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.PhoneNumberCannotBeEmpty')}`)
      }
      if (!form.weighingAddress) {
        throw new ErrorTip(`【${this.$t('SeaExport.VgmInfo')}】${this.$t('SeaExport.WeighingAddressCannotBeEmpty')}`)
      }
    },
    save() {
      const form = this.editDialog.form
      this.checkModel(form)
      if (!form.seq) {
        this.rowData.push(form)
      } else {
        const row = this.rowData.find(p => p.seq === form.seq)
        if (row) {
          Object.assign(row, form)
          this.gridApi.refreshCells({ force: true })
        }
      }
      // this.$message.success(this.$t('common.tips.saveSuccess'))
      this.editDialog.visible = false
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
      //   confirmButtonText: this.$t('common.btn.ok'),
      //   cancelButtonText: this.$t('common.btn.cancel'),
      //   type: 'warning'
      // }).then(async() => {
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        const row = this.rowData[i]
        if (rows.includes(row)) {
          if (row.uuid) {
            row.deleted = true
          } else {
            this.rowData.splice(i, 1)
          }
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        this.rowData = tempRowData
      })
      // this.$message.success(this.$t('common.tips.deleteSuccess'))
      // }).catch(() => { })
    },
    copyAndAddItem(params) {
      const source = params.data
      if (!this.isEditing) { // 查看
        this.showEditDialog(false, source)
        return
      }
      const newRow = new ManifestVGMInfo().fillDefaultValue().getData()
      newRow.soNo = source.soNo
      newRow.eqSize = source.eqSize
      newRow.containerNo = source.containerNo
      newRow.sealNo = source.sealNo
      newRow.vgmWeight = source.vgmWeight
      newRow.vgmWeightUnit = source.vgmWeightUnit
      newRow.vgmWeightingMeothd = source.vgmWeightingMeothd
      newRow.vgmLiabilityCompany = source.vgmLiabilityCompany
      newRow.vgmAutoGraph = source.vgmAutoGraph
      newRow.contactEmail = source.contactEmail
      newRow.grossWeight = source.grossWeight
      newRow.grossWeightUnit = source.grossWeightUnit
      newRow.telephone = source.telephone
      newRow.weighingAddress = source.weighingAddress
      newRow.weightTime = source.weightTime
      this.showEditDialog(true, newRow)
    },
    copy() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.ChooseContainerInfoToCopy'))
        return
      }
      // 添加勾选数据
      for (const row of rows) {
        const newRow = new ManifestVGMInfo().fillDefaultValue().getData()
        commonUtil.objCopy(row, newRow)
        newRow.uuid = ''
        this.rowData.push(newRow)
      }
    },
    // 转大写并去除空格
    toUpperCaseTrim(val) {
      return val.toUpperCase().trim()
    }
  }
}
</script>

<style>
</style>
